// Map of page route -> title
// NOTE: This needs to be updated whenever a new page is added.
// There's probably a better way in UI router to configure/communicate
// the name of the active route, but this is what we got for now.
const PAGE_NAMES = {
  home: 'Broadcasts',

  'bulk-import': 'Bulk Import',
  'caption-editor': 'Caption Editor',
  channels: 'Channels',
  'complete-migration': 'Complete Migration',
  contributors: 'Contributors',
  embed: 'Embed Code Generator',
  'extended-test': 'Create Extended Test',
  'marketing-corner': 'Upgrade Options',
  'multi-site': 'Multi-Site Player',
  'new-event': 'Schedule',
  resources: 'Resources',
  sources: 'Sources',
  uploads: 'Uploads',

  'settings.overview': 'Settings',
  'settings.integrations': 'Settings',
  'settings.users': 'Settings',
  'settings.facebook': 'Settings',
  'settings.my_account': 'Settings',
  'settings.payment': 'Settings',
  'settings.rtmp_push_channels': 'Settings',
  'settings.youtube': 'Settings',
  'settings.twitter': 'Settings',
  'settings.vimeo': 'Settings',

  events: 'Broadcasts',
  'events.detail': 'Broadcast Details',
  'events.edit': 'Edit Broadcast Details',
  'events.trim': 'Trim Recording',
  'events.highlights': 'Broadcast Highlights',

  reports: 'Reports',
  'reports.donations': 'Donations Report',
  'reports.tickets': 'Tickets Report',
  'reports.viewer': 'Viewer Analytics',
};

export default PAGE_NAMES;



// WEBPACK FOOTER //
// ./app/pages/page-names.js